import { api } from '@/fsd/shared/api';
import { IGetAccountResult } from '../../model/types/IGetAccountResult';

export const getAccount = async () => {
  const data = await api.get<IGetAccountResult>('/api/v1/account/');

  return data;
};
